import React, { Component } from 'react';
import DeleteAccountForm from './DeleteAccountForm';
import NavBar from '../NavBar/NavBar';
import './DeleteAccountPage.css';

class DeleteAccountPage extends Component {
  render () {
    return (
      <div className="DeleteAccountPage">
        <NavBar />
        <DeleteAccountForm />
      </div>
    )
  }
}

export default DeleteAccountPage;



// WEBPACK FOOTER //
// ./src/components/DeleteAccountPage/DeleteAccountPage.js